import React from 'react';
import PropTypes from 'prop-types';
import StudentRepository from '../services/StudentRepository.js';
import {
  TextField,
  Box,
  Button,
  CircularProgress,
  Alert,
  Typography,
  Tooltip,
} from '@mui/material';
import FormButtonGroup from '../components/layout/FormButtonGroup.jsx';

export default function Contact({
  repo,
  handleScreenNext,
  handleScreenBack,
  handleErrors,
  formValues,
  setFormValues,
  onSkip,
}) {
  const [loading, setLoading] = React.useState(false);
  const [buttonTooltip, setButtonTooltip] = React.useState('');
  const handleValueChange = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (!((formValues.contact_number || formValues.email) && formValues.social_media))
      setButtonTooltip('Social media and either contact number or email must be filled up.');
  };
  const isShiftable = () => {
    return (formValues.contact_number || formValues.email) && formValues.social_media && !loading;
  };
  const handleNext = async () => {
    setLoading(true);
    repo
      .updateContacts(formValues.contact_number, formValues.social_media, formValues.email)
      .then(() => {
        setLoading(false);
        handleScreenNext();
      })
      .catch(() => {
        setLoading(false);
        handleErrors(
          <Alert variant="filled" severity="error" sx={{ marginBottom: 3 }}>
            <Typography variant="caption">
              We are unable to reflect the changes in your contact channels. Please contact the
              administrator at webteam@msuiit.edu.ph.
            </Typography>
          </Alert>
        );
      });
  };
  return (
    <React.Fragment>
      <TextField
        id="contact_number"
        name="contact_number"
        label="Contact Number"
        variant="outlined"
        onChange={handleValueChange}
        value={formValues.contact_number ? formValues.contact_number : ''}
        fullWidth
      />
      <TextField
        id="email"
        name="email"
        label="Personal Email Address"
        variant="outlined"
        onChange={handleValueChange}
        value={formValues.email ? formValues.email : ''}
        fullWidth
      />
      <TextField
        id="social_media"
        name="social_media"
        label="Social Media Link"
        variant="outlined"
        onChange={handleValueChange}
        value={formValues.social_media ? formValues.social_media : ''}
        fullWidth
      />
      <Box sx={{ marginTop: '20px' }}>
        <FormButtonGroup>
          <Button variant="contained" size="large" color="error" onClick={() => handleScreenBack()}>
            Back
          </Button>
          {onSkip && (
            <Button
              variant="outlined"
              size="large"
              color="primary"
              onClick={onSkip}
              sx={{ marginRight: '10px' }}
            >
              Skip to Finish
            </Button>
          )}
          <Box sx={{ m: 0, position: 'relative' }}>
            <Tooltip title={buttonTooltip} arrow>
              <Button
                variant="contained"
                size="large"
                color="primary"
                disabled={!isShiftable()}
                onClick={handleNext}
              >
                Next
              </Button>
            </Tooltip>
            {loading && (
              <CircularProgress
                size={24}
                color={'success'}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )}
          </Box>
        </FormButtonGroup>
      </Box>
    </React.Fragment>
  );
}

Contact.propTypes = {
  repo: PropTypes.instanceOf(StudentRepository),
  studentId: PropTypes.string,
  handleScreenNext: PropTypes.func,
  handleScreenBack: PropTypes.func,
  handleErrors: PropTypes.func,
  formValues: PropTypes.object,
  setFormValues: PropTypes.func,
  onSkip: PropTypes.func,
};
